import { AppDispatch, RootState } from '..';
import { onAddingService, onDeletingService, onEditingService, onLoadingServices, setServices } from '../reducers';

import { REACT_APP_MANAGE_SERVICE_ENDPOINT } from '../types';
import axios from 'axios';
import { headers } from '.';
import { notification } from '../../utils';
import { serviceType } from '../../types';

export const getServices = () => async (dispatch: AppDispatch, getState: RootState) => {

    dispatch(onLoadingServices(true));

    const  { token } = getState().authReducer;
    const { company } = getState().companyReducer;

    const { data } = await axios.get(`${REACT_APP_MANAGE_SERVICE_ENDPOINT}/services/company/${company?.company_id}`, headers(token));

    const { services } = data;

    try {

        dispatch(setServices(services));
        dispatch(onLoadingServices(false));
        
    } catch (error: any) {

        dispatch(onLoadingServices(false));
        console.error('Get services error: ', error.message);
        
    }

};

export const addService = (service: serviceType) => async (dispatch: AppDispatch, getState: RootState) => {

    dispatch(onAddingService(true));

    const { token } = getState().authReducer;

    const { data } = await axios.post(`${REACT_APP_MANAGE_SERVICE_ENDPOINT}/service/add`, {...service}, headers(token));

    const { success, message } = data;

    try {

        notification(success ? 'Success' : 'error', message);
        dispatch(onAddingService(false));
        dispatch(getServices());
        
    } catch (error: any) {

        notification('error', message);
        dispatch(onAddingService(false));
        console.error('Add services error: ', error.message);
        
    }

};

export const editService = (service: serviceType) => async (dispatch: AppDispatch, getState: RootState) => {

    dispatch(onEditingService(true));

    const { token } = getState().authReducer;

    const { data } = await axios.put(`${REACT_APP_MANAGE_SERVICE_ENDPOINT}/service/update`, {...service}, headers(token));

    const { success, message } = data;

    try {

        notification(success ? 'success' : 'error', message);
        dispatch(onEditingService(false));
        dispatch(getServices());
        
    } catch (error: any) {

        notification('error', message);
        dispatch(onEditingService(false));
        console.error('Edit services error: ', error.message);
        
    }

};

export const deleteService = (id: string) => async (dispatch: AppDispatch, getState: RootState) => {

    dispatch(onDeletingService(true));

    const { token } = getState().authReducer;

    const { data } = await axios.delete(`${REACT_APP_MANAGE_SERVICE_ENDPOINT}/service/${id}/delete`, headers(token));

    const { success, message } = data;

    try {

        notification(success ? 'success' : 'error', message);
        dispatch(onDeletingService(false));
        dispatch(getServices());
        
    } catch (error: any) {

        notification('error', message);
        dispatch(onDeletingService(false));
        console.error('Delete services error: ', error.message);
        
    }

};